import api from "@/lib/api";

const CHUNK = 2 * 1024 * 1024;

// Chunked upload → Emergent Object Storage via backend. Resolves {url, name, size, content_type, kind}.
export async function uploadMedia(file, kind, onProgress) {
  const uploadId = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}${Math.random()}`).replace(/[^A-Za-z0-9_-]/g, "").slice(0, 40);
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  let last = null;
  for (let i = 0; i < total; i += 1) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", String(i));
    fd.append("total", String(total));
    fd.append("filename", file.name);
    fd.append("content_type", file.type || guessType(file.name));
    fd.append("kind", kind);
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    const { data } = await api.post("/uploads/chunk", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 120000 });
    last = data;
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return last;
}

function guessType(name) {
  const ext = name.split(".").pop().toLowerCase();
  return { jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", webp: "image/webp", heic: "image/heic", mp4: "video/mp4", mov: "video/quicktime", webm: "video/webm", pdf: "application/pdf" }[ext] || "";
}

export const MAX_PHOTOS = 50;
export const MAX_VIDEOS = 2;
